import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import useLocalStorage from 'use-local-storage';
import defaultImage from "../../../src/assets/images/blogs-images/download.jpg";
import blog1 from "../../../src/assets/images/blogs-images/1.png";
import blog2 from "../../../src/assets/images/blogs-images/2.png";
import blog3 from "../../../src/assets/images/blogs-images/3.png";
import blog4 from "../../../src/assets/images/blogs-images/4.png";

Footer.propTypes = {

};
function Footer(props) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);

    const blogs = [
        {
            id: 1,
            link: "/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills",
            img: blog1, // Replace with your imported image path
            // author: "Stephen Andrew",
            title: "Recruiters Say 'No More Resu-mehs’ as Skills Shine Over Spills",
            detail: "Traditional resumes are losing their once-unquestionable prominence as the foundation of the hiring process. "
            // date: "Oct 16, 2019",
            // timeToRead: "8 min read",
        },
        {
            id: 2,
            link: "/blogs/Crafting-a-Genuine-Learning-Experience-for-Success-in-the-Workplace",
            img: blog2, // Replace with your imported image path
            // author: "Stephen Andrew",
            title: "Crafting a Genuine Learning Experience for Success in the Workplace",
            detail: "The landscape of a learning culture is vast and multifaceted, with the power to propel productivity, spur innovation, and instill confidence in individuals."
            // date: "Oct 16, 2019",
            // timeToRead: "8 min read",
        },
        {
            id: 3,
            link: "/blogs/A-Strategic-Approach-to-Closing-Skill-Gaps-in-the-Digital-Age",
            img: blog3, // Replace with your imported image path
            // author: "Stephen Andrew",
            title: "A Strategic Approach to Closing Skill Gaps in the Digital Age",
            detail: "Organizations that want to thrive, especially during volatility and disruption generated by rapidly evolving technologies like AI and ML."
            // date: "Oct 16, 2019",
            // timeToRead: "8 min read",
        },
        {
            id: 4,
            link: "/blogs/How-to-Retain-Your-Top-Performers-by-Building-Inclusive-Workplaces",
            img: blog4, // Replace with your imported image path
            // author: "Stephen Andrew",
            title: "How to Retain Your Top Performers by Building Inclusive Workplaces",
            detail: "A lot is going on in today's fast-paced world, and the battle to retain top performers takes center stage in conversations about organizational performance."
            // date: "Oct 16, 2019",
            // timeToRead: "8 min read",
        },
    ];

    const [currentBlogIndex, setCurrentBlogIndex] = useState(0);

    useEffect(() => {
        const updateBlogIndex = () => {
            // const hoursElapsed = Math.floor(Date.now() / ( 1000)); // Divide Unix time into 3-hour intervals
            const hoursElapsed = Math.floor(Date.now() / (3 * 60 * 60 * 1000)); // Divide Unix time into 3-hour intervals
            const index = hoursElapsed % blogs.length; // Get the index cyclically
            setCurrentBlogIndex(index);
        };

        updateBlogIndex(); // Run on mount
        const interval = setInterval(updateBlogIndex, 1000); // Check every second (or adjust as needed)

        return () => clearInterval(interval); // Cleanup the interval on unmount
    }, [blogs.length]);

    const navigate = useNavigate();
        const location = useLocation();
    
        const handleNavigation = (path) => {
            if (location.pathname === path) {
                window.location.reload(); // Force a full page reload
            } else {
                navigate(path);
            }
        };

    const currentBlog = blogs[currentBlogIndex];

    return (
        <footer className="footer">
            <div className="container">
                <div className="top-footer">
                    <div className="container">

                    </div>
                </div>
                <div className="inner-footer New-Khoj-Inner-Footer">
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-lg-3 col-md-6">
                                <Link to="/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills">
                                    <div className="blogs-container">
                                        <div className="blogs-list">
                                            <div className="blogs">
                                                <div className="blogs-image me-4 mt-2"><img src={blog1} alt="" srcset="" /></div>
                                                <div>
                                                    <p className='my-2'>Stephen adrew  <span>Blog 1</span></p>
                                                    <div className="blogs-title f-700 mb-2">5 Digital marketing jobs in delhi to start your career.</div>
                                                    <div className="blogs-date f-12">Oct 16, 2019 . 8 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/blogs/Crafting-a-Genuine-Learning-Experience-for-Success-in-the-Workplace">
                                    <div className="blogs-container">
                                        <div className="blogs-list">
                                            <div className="blogs">
                                                <div className="blogs-image me-4 mt-2"><img src={blog2} alt="" srcset="" /></div>
                                                <div>
                                                    <p className='my-2'>Stephen adrew <span>Blog 2</span></p>
                                                    <div className="blogs-title f-700 mb-2">5 Digital marketing jobs in delhi to start your career.</div>
                                                    <div className="blogs-date f-12">Oct 16, 2019 . 8 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills">
                                    <div className="blogs-container">
                                        <div className="blogs-list">
                                            <div className="blogs">
                                                <div className="blogs-image me-4 mt-2"><img src={blog3} alt="" srcset="" /></div>
                                                <div>
                                                    <p className='my-2'>Stephen adrew  <span>Blog 3</span></p>
                                                    <div className="blogs-title f-700 mb-2">5 Digital marketing jobs in delhi to start your career.</div>
                                                    <div className="blogs-date f-12">Oct 16, 2019 . 8 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/blogs/Recruiters-Say-'No-More-Resu-mehs’-as-Skills-Shine-Over-Spills">
                                    <div className="blogs-container">
                                        <div className="blogs-list">
                                            <div className="blogs">
                                                <div className="blogs-image me-4 mt-2"><img src={blog4} alt="" srcset="" /></div>
                                                <div>
                                                    <p className='my-2'>Stephen adrew <span>Blog 4</span></p>
                                                    <div className="blogs-title f-700 mb-2">5 Digital marketing jobs in delhi to start your career.</div>
                                                    <div className="blogs-date f-12">Oct 16, 2019 . 8 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div> */}
                            <div className="col-lg-3 col-md-6">
                                <Link to={currentBlog.link} onClick={() => handleNavigation(currentBlog.id)}>
                                    <div className="blogs-container">
                                        <div className="blogs-list">
                                            <div className="blogs me-2">
                                                <div className="blogs-image mb-2 mt-2">
                                                    <img src={currentBlog.img} alt={`Blog ${currentBlog.id}`} />
                                                </div>
                                                <div>
                                                    {/* <p className="my-2">
                                                        {currentBlog.author}  
                                                    </p> */}
                                                    <div className="blogs-title f-700 mb-2 f-13">{currentBlog.title}</div>
                                                    <div className="blogs-title f-500 mb-2 f-12">{currentBlog.detail}</div>
                                                    <div className="blogs-date f-12">
                                                        {currentBlog.date}  {currentBlog.timeToRead}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-6 col-6">
                                <div className="footer-cl-2">
                                    <h6 className="ft-title f-18">
                                    </h6>
                                    <ul className="navigation-menu-footer p-0">
                                        <h6 className='f-600 f-22'>Khoj</h6>
                                        <li> <NavLink className="NavLink-custom-color" to="/About-Us" onClick={() => handleNavigation("/About-Us")}>About Us</NavLink> </li>
                                        <li>
                                            <NavLink className="NavLink-custom-color" to="/About-Us#Service"  >Services</NavLink>
                                        </li>
                                        <li> <NavLink className="NavLink-custom-color" to="/Contact" onClick={() => handleNavigation("/Contact")}>Contact Us</NavLink> </li>
                                        <li> <NavLink className="NavLink-custom-color" to="/Work-with-us" onClick={() => handleNavigation("/Work-with-us")}>Work with Us</NavLink> </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 col-6 info-mobile-css">
                                <div className="wd-social d-flex aln-center justify-content-start mb-3">
                                </div>
                                <ul className="navigation-menu-footer p-0">
                                    <h6 className='f-600 f-22'>Information</h6>
                                    <li> <NavLink className="NavLink-custom-color" to="/Guidelines" onClick={() => handleNavigation("/Guidelines")}>Guidelines</NavLink> </li>
                                    <li> <NavLink className="NavLink-custom-color" to="/Terms-and-Conditions" onClick={() => handleNavigation("/Terms-and-Conditions")}>Terms And Conditions</NavLink> </li>
                                    <li> <NavLink className="NavLink-custom-color" to="/Privacy-Policy" onClick={() => handleNavigation("/Privacy-Policy")}>Privacy Policy</NavLink> </li>
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 Khoj-Icon-Para-Class">
                                <div className="footer-logo d-flex justify-content-center mb-3">
                                    {isDark ? (
                                        <div id="logo" className="logo">
                                            <Link to="/">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={require('../../assets/images/logo2.png')}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    ) : (
                                        <div id="logo" className="logo">
                                            <Link to="/">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={require('../../assets/images/logo.png')}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    )}
                                </div>
                                <div className="content mb-4 text-center">
                                    Weaving Dreams into Destinies, Sculpting Futures with Resolve.
                                </div>
                                <ul className="list-social  p-0 d-flex align-items-center justify-content-center">
                                    <li className=''><Link to="https://www.facebook.com/profile.php?id=61571453613558" target='blank'><i className="icon-facebook"></i></Link></li>
                                    <li className=''><Link to="https://www.linkedin.com/showcase/job-ki-khoj/about/?viewAsMember=true" target='blank'><i className="icon-linkedin2"></i></Link></li>
                                    <li><Link to="https://www.instagram.com/jobkikhoj_insta/" target='blank'><i className="icon-instagram1"></i></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom New-Khoj-Inner-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="">
                                    <div className="copyright mt-3 text-center">©2025 Khoj. All Rights Reserved.</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;